<div class="mt-3 text-center">
  @if (downloading) {
    <h1>
      Téléchargement en cours
    </h1>
  }
  @if (! downloading) {
    <h1>
      Téléchargement terminé, vous pouvez fermer cette fenêtre
    </h1>
  }
</div>
